import clsx from 'clsx';

interface IMessageWrapperProps {
  parentClName?: string;
  childClName?: string;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const MessageWrapper = (props: IMessageWrapperProps) => {
  return (
    <div className={clsx('mb-2', props.parentClName)} onClick={props.onClick}>
      <div className={clsx('p-5 rounded-sm flex bg-white dark:bg-soft-black', props.childClName)}>{props.children}</div>
    </div>
  );
};
